export default () => ({
  entity: 'schedule',
  schedule: {
    id: null,
    date: null,
    time: null,
    patient: null,
    covenant: null,
    company: null
  }
})



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/next-patient/resources/data.js